/* §9.4: staff-issued invitation links carry the one-time token in the URL
 * fragment (`/activate#t=<token>`) so it never reaches server logs, Caddy logs
 * or the Referer header. The SPA reads it from location.hash; the ?token=
 * query remains only as a defensive fallback for legacy links. */
export function activationToken(search: string, hash: string): string {
  const raw = hash.replace(/^#/, '');
  const hashToken = new URLSearchParams(raw.startsWith('t=') ? raw : '').get('t');
  if (hashToken) return hashToken;
  return new URLSearchParams(search).get('token') ?? '';
}
